import type { TDocumentDefinitions } from 'pdfmake/interfaces';

export interface PdfMakeFontDefinition {
  normal: string;
  bold?: string;
  italics?: string;
  bolditalics?: string;
}

export type PdfMakeFonts = Record<string, PdfMakeFontDefinition>;
export type PdfMakeVfs = Record<string, string>;
export type PdfMakeTableLayouts = Record<string, unknown>;

export interface PdfDocumentHandle {
  getBlob(callback: (blob: Blob) => void): void;
}

export interface PdfMakeClient {
  createPdf(
    documentDefinition: TDocumentDefinitions,
    tableLayouts?: PdfMakeTableLayouts,
    fonts?: PdfMakeFonts,
    vfs?: PdfMakeVfs,
  ): PdfDocumentHandle;
}

export interface CreateReportPdfBlobOptions {
  documentDefinition: TDocumentDefinitions;
  pdfMake: PdfMakeClient;
  fonts: PdfMakeFonts;
  vfs: PdfMakeVfs;
  tableLayouts?: PdfMakeTableLayouts;
}

export const HEBREW_REPORT_FONTS: PdfMakeFonts = {
  Heebo: {
    normal: 'Heebo.ttf',
    bold: 'Heebo.ttf',
    italics: 'Heebo.ttf',
    bolditalics: 'Heebo.ttf',
  },
  Rubik: {
    normal: 'Rubik.ttf',
    bold: 'Rubik.ttf',
    italics: 'Rubik.ttf',
    bolditalics: 'Rubik.ttf',
  },
};

export function createReportPdfBlob(options: CreateReportPdfBlobOptions): Promise<Blob> {
  return new Promise((resolve, reject) => {
    try {
      const document = options.pdfMake.createPdf(
        options.documentDefinition,
        options.tableLayouts,
        options.fonts,
        options.vfs,
      );
      document.getBlob(resolve);
    } catch (error) {
      reject(error);
    }
  });
}
